/** Narrow shape we use from `chrome.runtime` on web pages (sign-out clear). */
export interface MinimalChromeRuntime {
  sendMessage(
    extensionIdOrMessage: string | Record<string, unknown>,
    messageOrResponseCallback?: Record<string, unknown> | (() => void),
    responseCallback?: () => void
  ): void;
}

interface MinimalChrome {
  runtime?: MinimalChromeRuntime;
}

/**
 * Optional Chrome extension runtime (web pages may run outside extension context).
 */
export function getChromeRuntime(): MinimalChromeRuntime | undefined {
  const chromeRef = (globalThis as unknown as { chrome?: MinimalChrome }).chrome;
  const rt = chromeRef?.runtime;
  if (typeof rt?.sendMessage !== 'function') return undefined;
  return rt;
}
